import React, { useState } from "react";
import Modalform from "./Modalform";
import { useLocation, Link } from "react-router-dom";

function Footer() {
  const [showModal, setShowModal] = useState(false);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const location = useLocation();
  const pathSegments = location.pathname.split("/");
  const locationName = pathSegments[1] || "Home";

  return (
    <>
      <footer id="footer">
        {/* Optional footer content can go here */}

        {/* ✅ Inline CSS (scoped to this component) */}
        <style>{`
          .chat-btn {
            position: fixed;
            bottom: 25px;
            left: 25px;
            background-color: #e04495;
            color: white;
            border: none;
            border-radius: 50px;
            padding: 12px 20px;
            font-size: 16px;
            font-weight: 500;
            cursor: pointer;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
            transition: all 0.3s ease;
            z-index: 9999;
          }
          .chat-btn:hover {
            background-color: #0056b3;
          }
          .whatsapp-btn {
            position: fixed;
            bottom: 25px;
            right: 25px;
            background-color: #25D366;
            border-radius: 50%;
            width: 60px;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
            z-index: 9999;
            transition: all 0.3s ease;
          }
          .whatsapp-btn img {
            width: 32px;
            height: 32px;
          }
          .whatsapp-btn:hover {
            transform: scale(1.1);
          }
        `}</style>

        {/* 💬 Chat Us Button (left bottom) */}
        <button onClick={handleShow} className="chat-btn">
          💬 Chat Us
        </button>

        {/* 🟢 WhatsApp Button (right bottom) */}
        {/* <a
          href="https://wa.me/919915447777"
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-btn"
        >
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
            alt="WhatsApp"
          />
        </a> */}

        {/* Modal Form */}
        <Modalform showModal={showModal} handleClose={handleClose} />
      </footer>
    </>
  );
}

export default Footer;
